module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fillingDeta.subjectType === 0) ? _c('div', {
    staticClass: "box"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "box-t-l"
  }, [_c('p', [_vm._v("文件列表")]), _vm._v(" "), _c('ul', {
    staticClass: "ull"
  }, _vm._l((_vm.fillingDeta.plandoc), function(m, index) {
    return _c('li', {
      key: index,
      class: {
        activess: _vm.activeli === index
      },
      on: {
        "click": function($event) {
          _vm.getfile(m, index)
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "label",
        "title": _vm.formatPlanDoc(m.type)
      },
      slot: "label"
    }, [_vm._v("\n              " + _vm._s(_vm.formatPlanDoc(m.type)))])])
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "box-pdf box-t-r"
  }, [_c('pdf', {
    attrs: {
      "src": _vm.srcaddress,
      "activeData": _vm.activeData,
      "canReupload": false
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "box-t-rb"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName2),
      callback: function($$v) {
        _vm.activeName2 = $$v
      },
      expression: "activeName2"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "申报单位信息",
      "name": "second"
    }
  }, [_c('p', [_c('span', [_vm._v("企业全称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.subjectName))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("中心坐标：")]), _vm._v(" "), _c('span', [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.latitude)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.code))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("行业：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ChangeName(_vm.fillingDeta.industry)))])]), _vm._v(" "), _c('p', {
    staticClass: "flex flex-vc flex-hs"
  }, [_c('span', [_vm._v("营业执照：")]), _vm._v(" "), _c('span', {
    staticClass: "a-hover relative",
    on: {
      "click": function($event) {
        _vm.previewImg(_vm.fillingDeta.imgName)
      }
    }
  }, [_c('viewer', {
    staticClass: "seeBigImg",
    attrs: {
      "images": _vm.photo
    }
  }, _vm._l((_vm.photo), function(src, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": src
      }
    })
  }))], 1)]), _vm._v(" "), _c('p', [_c('span', [_vm._v("企业法人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.legalPerson))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系电话：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.phone))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("注册地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.provinceName) + " " + _vm._s(_vm.fillingDeta.cityName) + " " + _vm._s(_vm.fillingDeta.countyName) + " " + _vm._s(_vm.fillingDeta.address))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fillingDeta.zone),
      expression: "fillingDeta.zone"
    }]
  }, [_c('span', [_vm._v("所属工业园区：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatZone(_vm.fillingDeta.zone)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("所属区划类型")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatRegionType(_vm.fillingDeta.regionType)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("所属区划：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getRegions(_vm.fillingDeta.regions))
    }
  })]), _vm._v(" "), (_vm.fillingDeta.subjectType == 0 && _vm.fillingDeta.delegated == true) ? _c('div', [_c('p', [_c('span', [_vm._v("编制单位名称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.delegateOrgName))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("编制单位地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.delegateOrgAddr))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("编制单位联系人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.delegateOrgLinkMan))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("编制单位联系电话：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.delegateOrgPhone))])])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "预案概要",
      "name": "four"
    }
  }, [_c('digitization')], 1)], 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fillingDeta.subjectType === 1 || _vm.fillingDeta.subjectType === 3 || _vm.fillingDeta.subjectType === 4) ? _c('div', {
    staticClass: "box"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "box-t-l"
  }, [_c('p', [_vm._v("文件列表")]), _vm._v(" "), _c('ul', {
    staticClass: "ull"
  }, _vm._l((_vm.fillingDeta.plandoc), function(m, index) {
    return _c('li', {
      key: index,
      class: {
        activess: _vm.activeli === index
      },
      on: {
        "click": function($event) {
          _vm.getfile(m, index)
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "label",
        "title": _vm.formatPlanDoc(m.type)
      },
      slot: "label"
    }, [_vm._v("\n                " + _vm._s(_vm.formatPlanDoc(m.type)))])])
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "box-pdf box-t-r"
  }, [_c('pdf', {
    attrs: {
      "src": _vm.srcaddress,
      "activeData": _vm.activeData,
      "canReupload": false
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "box-t-rb"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName2),
      callback: function($$v) {
        _vm.activeName2 = $$v
      },
      expression: "activeName2"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "申报单位信息",
      "name": "second"
    }
  }, [_c('p', [_c('span', [_vm._v("企业全称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.subjectName))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("中心坐标：")]), _vm._v(" "), _c('span', [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.latitude)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("单位地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.address))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("所属区划：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getRegions(_vm.fillingDeta.regions)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.linkMan))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系电话：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.phone))])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "预案概要",
      "name": "four"
    }
  })], 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fillingDeta.subjectType === 2) ? _c('div', {
    staticClass: "box"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "box-t-l"
  }, [_c('p', [_vm._v("文件列表")]), _vm._v(" "), _c('ul', {
    staticClass: "ull"
  }, _vm._l((_vm.fillingDeta.plandoc), function(m, index) {
    return _c('li', {
      key: index,
      class: {
        activess: _vm.activeli === index
      },
      on: {
        "click": function($event) {
          _vm.getfile(m, index)
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "label",
        "title": _vm.formatPlanDoc(m.type)
      },
      slot: "label"
    }, [_vm._v("\n         " + _vm._s(_vm.formatPlanDoc(m.type)))])])
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "box-pdf box-t-r"
  }, [_c('pdf', {
    attrs: {
      "src": _vm.srcaddress,
      "activeData": _vm.activeData,
      "canReupload": false
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "box-t-rb"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName2),
      callback: function($$v) {
        _vm.activeName2 = $$v
      },
      expression: "activeName2"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "备案信息",
      "name": "first"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v("备案流水号： " + _vm._s(_vm.fillingDeta.serialCode))])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "申报单位信息",
      "name": "second"
    }
  }, [_c('p', [_c('span', [_vm._v("园区全称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.subjectName))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("中心坐标：")]), _vm._v(" "), _c('span', [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.fillingDeta.latitude)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.linkMan))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系电话：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.phone))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("注册地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fillingDeta.provinceName) + " " + _vm._s(_vm.fillingDeta.cityName) + " " + _vm._s(_vm.fillingDeta.countyName) + " " + _vm._s(_vm.fillingDeta.address))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("所属区划类型")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatRegionType(_vm.fillingDeta.regionType)))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("所属区划：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getRegions(_vm.fillingDeta.regions))
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "预案概要",
      "name": "four"
    }
  }, [_vm._v("\n              暂无信息\n            ")])], 1)], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "width": "100%"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddd3661","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/burst/BurstfillInfo.vue
// module id = 1213
// module chunks = 2